<template>
  <div class="page_wrapper">
    <div class="base">
      <br>
      <div
        class="box"
        :style="{'text-align': 'left'}"
      >
        <h3>Q: Do Max and Christina have a COVID plan?!</h3>
        <div class="center">
          <img src="../assets/images/only_you.png"/>
        </div>
        <p class="center"><strong>Can stop the spread of Coronavirus! But we can help...</strong></p>
        <p>
        <h3>Links:</h3>
        <ul>
          <li>
            <a href="https://www.health.pa.gov/topics/disease/coronavirus/Pages/Coronavirus.aspx">Pennsylvania Department of Health</a>
          </li>
          <li>
            <a href="https://www.cdc.gov/coronavirus/2019-ncov/index.html">CDC</a>
          </li>
        </ul>
        <h3>Some stuff we recommend:</h3>
        <ul>
          <li>
          1. If you don’t feel good, stay away. You should probably sleep. We love sleeping.
          </li>
          <br>
          <li>
          2. Keep your breath to yourself! Masks!
            <p></p>
            <ol>
              <li>- At the party, please try to wear one when not actively putting something in your mouth (eating/drinking/flossing your teeth). If you don’t, you will make the caterers uncomfortable. It will be awkward. No one likes that.</li>
              <br>
              <li>- In the church, you must wear a face mask --> Church rules-</li>
              <br>
              <ol>
              <li>+ In the church you will be social distancing by family unit.</li>
              <br>
              <li>+ If you don’t like your family, we recommend not breathing.</li>
              <br>
              </ol>
              <li>- If you forget your mask, never fear! We will have lots of disposable masks. Christina’s mom found a good sale on Amazon.</li>
            </ol>
          </li>
          <br>
          <li>
            3. Social distance yourself!
            The farm is big! Explore the whole thing. Activities include:
            <ol>
              <br>
              <li>1. eating</li>
              <li>2. drinking</li>
              <li>3. whack-a-mole and skee ball</li>
              <li>4. lawn games</li>
              <li>5. fire pit</li>
              <li>6. music</li>
              <li>7. random animals to visit, pet and feed</li>
              <br>
              <li>
                Keep 6 ft away from people in other social bubbles when eating or drinking.
                We will have garden tables in the eating area and lots of orange tarps on the ground appropriately spaced for your dining, picnicking, and dancing pleasure
              </li>
            </ol>
          </li>
          <br>
            <li>
              4. Wash yourself:
              <ol>
                <br>
                <li>Bathrooms- we rented nice bathrooms for you to wash your hands as often as you need to</li>
                <br>
                <li>Hand sanitizer- we will have hand sanitizer on all the tables and near all activities, like the arcade games. You should probably sanitize after you play the games. And also after you pet the animals (campylobacter, like covid is also unpleasant)</li>
              </ol>
            </li>
        </ul>
        <h3>Food:</h3>
          <ul>
            <li>Food consists of passed appetizers, and individually plated small meals. The way it works is you go to 	the food station and you tell the chef what you want. The chef assembles your tiny meal for you on a plate 	and gives it to you. You then return to your socially isolated social bubble, or get another meal, or maybe 	three, you pig! When it is dessert time, its the same process but tastier.</li>
          </ul>
        <h3>If you get COVID after the event:</h3>
          <ul>
            <li>
               Please don’t let us know. We don’t want to hear.
            </li>
            <li>
              Just kidding!!! You should tell us. We will make sure to pass on the details to others. Please don’t get it though. I hear it has a worse rating on amazon than sugar free gummy
            </li>
          </ul>
      </div>
      <br>
      <div
          class="box"
          :style="{'text-align': 'left'}"
      >
        <h3>Q: Dress code: What should I wear to this ball?</h3>
        <ul>
          <li>
            Whatever you want. If you are going to the church, wear something you could wear in a church without scandalizing the priest. At the farm, wear something you would wear to a farm that has clothes-eating-goats, dirt and hills. We are wearing fancy clothes, but we make no guarantees for the integrity of your fancy clothes when goats are present. May we advise against the stilettos though. If you ignore us and wear stilettos anyway bring your own crutches and ankle wrap.
          </li>
        </ul>
      </div>
      <br>
      <div
          class="box"
          :style="{'text-align': 'left'}"
      >
        <h3>Q: Will there be food I like?</h3>
        <ul>
          <li>
            If you don’t like roast pig, made to order stir fry, steak, seafood, vegetables, or dessert, sorry, you better BYO.
          </li>
        </ul>
      </div>
      <br>
      <div
          class="box"
          :style="{'text-align': 'left'}"
      >
        <h3>Q: Will there be drinks?</h3>
        <ul>
          <li>
            Yes. The Irish Catholic wedding will have an Open bar. May we recommend the cocktails bar. There is also, a juice bar. Not sure which one is which.
          </li>
        </ul>
      </div>
      <br>
      <div
          class="box"
          :style="{'text-align': 'left'}"
      >
        <h3>Q: I got my money’s worth out of the cocktails. How do I get home?</h3>
        <ul>
          <li>
            That is why we have a shuttle to take you back to the hotel. Luckily the Shuttle is no optional so you will be at a safe place to sleep
          </li>
        </ul>
      </div>
      <br>
      <div
          class="box"
          :style="{'text-align': 'left'}"
      >
        <h3>Q: What if I have more questions?</h3>
        <ul>
          <li>
            Please submit your questions in triplicate to your local chapter representative. This will be forwarded for consideration on the 4th Thursday of the 3rd and 10th month.
          </li>
        </ul>
      </div>
      <br>
      <div
          class="box"
          :style="{'text-align': 'left'}"
      >
        <h3>Q: We keep hearing about this shuttle.</h3>
        <ul>
          <li>
            That’s not actually a question but yes, Our wedding reception is on a farm that is also someone’s house. There are too many goats so there just isn’t parking for 100 people. Please take the shuttle or a rideshare. The church has parking so there is no shuttle between the hotel and church. It is about a 30 minute drive. Waze is your friend.


            For the reception, two shuttles will start picking people up at the hotel at 5:00pm to go to the farm. It will make loops to take you back to the hotel from the farm whenever you want to go back.
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "Faq"
}
</script>

<style scoped>
  .center {
    display: flex;
    margin:50px;
    justify-content: center;
    align-items: center;
    height: 200px;
  }
</style>
